import React from 'react';
import PropTypes from 'prop-types';
import {callAction} from 'client/framework';
import classnames from 'classnames';
import constants from 'client/constants';
import questionEditorActions from './QuestionEditor.actions';
import Button from 'sg/Button/Button.react';

export default class DifficultyEditor extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    difficulty: PropTypes.number,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  };

  changeDifficulty(difficulty) {
    callAction(questionEditorActions.UPDATE_QUESTION_DETAILS, {
      setter: 'setDifficulty',
      value: difficulty
    });
  }

  render() {
    const easyValue = constants.QUESTION_IMPORT.DIFFICULTIES.Easy;
    const moderateValue = constants.QUESTION_IMPORT.DIFFICULTIES.Moderate;
    const difficultValue = constants.QUESTION_IMPORT.DIFFICULTIES.Difficult;
    const easyDifficultySelect = classnames('question-editor__difficulty-select-option', 'easy', {
      selected: this.props.difficulty === easyValue
    });
    const moderateDifficultySelect = classnames(
      'question-editor__difficulty-select-option',
      'moderate',
      {
        selected: this.props.difficulty === moderateValue
      }
    );
    const hardDifficultySelect = classnames('question-editor__difficulty-select-option', 'hard', {
      selected: this.props.difficulty === difficultValue
    });

    const difficultySelectorClassnames = classnames(
      'question-editor__difficulty-select',
      this.props.className
    );

    return (
      <div className={difficultySelectorClassnames}>
        <div className='a-form-input__label'>Difficulty</div>
        <Button className={easyDifficultySelect} onClick={() => this.changeDifficulty(easyValue)}>
          <span className='fa fa-star' />
          <br />
          <span className='label'>Easy</span>
        </Button>
        <Button
          className={moderateDifficultySelect}
          onClick={() => this.changeDifficulty(moderateValue)}
        >
          <span className='fa fa-star' />
          <span className='fa fa-star' />
          <span className='fa fa-star' />
          <br />
          <span className='label'>Moderate</span>
        </Button>
        <Button
          className={hardDifficultySelect}
          onClick={() => this.changeDifficulty(difficultValue)}
        >
          <span className='fa fa-star' />
          <span className='fa fa-star' />
          <span className='fa fa-star' />
          <span className='fa fa-star' />
          <span className='fa fa-star' />
          <br />
          <span className='label'>Difficult</span>
        </Button>
        <div className='a-form-input__error'>
          {this.props.error ? this.props.errorMessage : null}
        </div>
      </div>
    );
  }
}
